import { render, staticRenderFns } from "./MallHotelRoom.vue?vue&type=template&id=e81cd7ba&scoped=true&"
import script from "./MallHotelRoom.vue?vue&type=script&lang=js&"
export * from "./MallHotelRoom.vue?vue&type=script&lang=js&"
import style0 from "./MallHotelRoom.vue?vue&type=style&index=0&id=e81cd7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81cd7ba",
  null
  
)

export default component.exports